import { Type } from '@angular/core';

export class DevFuncActionItem {
  constructor(public component: Type<any>, public name: string, public data?: any) {}
}
